import moment = require("moment");
import { getAsNumber, isNumber, isString } from "./components/utilities";
import { DateToString, translate } from "src/common/utilities";
declare var currentSystemLanguage;


export class Converters {
    notConverter(t) {
        return !t;
    }
    numberToString(n: number) {
        if (n)
            return n.toString();
        return "0";
    }
    stringToInt(s: string) {
        if (s == null)
            return 0;
        let v = parseInt(s);
        if (isNaN(v))
            return 0;
        return v;
    }

    onlyDatePersianMonthYearDateConverter(d: moment.Moment): string {
        return DateToString(d, currentSystemLanguage, `YYYY/MM`, true);
    }

    onlyTimePersianMonthYearDateConverter(d: moment.Moment): string {
        return DateToString(d, currentSystemLanguage, `HH:mm`, true);
    }

    onlyDatePersianDateConverter(d: moment.Moment): string {
        return DateToString(d, currentSystemLanguage, `YYYY/MM/DD`, true);
    }

    persianDateConverter(d: moment.Moment, separator?: string): string {
        if (separator == null) separator = '|';
        let format = `HH:mm:ss ${separator} dddd YYYY/MM/DD`;
        return DateToString(d, currentSystemLanguage, format, true);
    }



    colorStatusConverterForListOfRequestsInOfficeApp(c) {
        switch (c) {
            case 0:
                return 'transparent';
            case 1:
                return 'var(--color6opac2)';
            case 2:
                return 'var(--color6opac2)';
            case 3:
                return 'var(--color8opac2)';
            case 4:
                return 'var(--color9opac2)';
            case 5:
                return 'var(--color4opac2)';
        }
        return 'transparent';
    }

    moneyConverter(v) {
        if (v) {
            let thousandSeparated = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return translate("converters.thousandSeparated", { thousandSeparatedText: thousandSeparated });
        } else {
            return translate("converters.rial", {});
        }
    }
    reverseMoneyConverter(v) {
        if (v && isString(v)) {
            let thousandSeparated = (<string>v).split(' ')[0];
            let numberString = thousandSeparated.replace(/,/g, "");
            return getAsNumber(numberString);
        } else {
            return 0;
        }
    }

    b64ToSrcConverter(t) {
        return `data:image/png;base64,${t}`;
    }
    b64ToSrcConverterReverse(t) {
        if (t && isString(t) && t.indexOf(',') > -1)
            return t.split(',')[1];
        return null;
    }
}